<section class="pt-16 pb-8 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Spettacoli', route: '/backoffice/spettacoli' }]"></app-breadcrumb-backoffice>
    <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">Spettacoli</h1>
</section>

<section class="pb-16 mb-8 px-container" #lista>

    <div class="row w-full flex lg:justify-end">
        <button class="p-3 lg:w-1/4 w-full btn-outln-backoffice mb-8 text-center" type="button" routerLink="/backoffice/spettacoli/add">
            <i class="bi bi-plus"></i>
            Aggiungi spettacolo
        </button>
    </div>

    <p-table
        #table        
        [loading]="loading" 
        [value]="spettacoli_filterd"
        [paginator]="true"
        [rows]="5"
        [first]="pagina"
        [rowHover]="true"
        [showCurrentPageReport]="true"        
        currentPageReportTemplate="{first} di {last} su {totalRecords} spettacoli"
        (onPage)="onPageChange($event, lista)"        
        (onFilter)="onFiltro($event)"
        [rowsPerPageOptions]="[5, 10, 20, 50, 100, 150, 200, 250, 500]"
        responsiveLayout="stack" [breakpoint]="'960px'"
        [resetPageOnSort]="false"
        styleClass="p-datatable-striped">
        <ng-template pTemplate="header">
            <tr class="border-t border-b">
                <th class="w-1/5 text-center">Immagine</th>
                <th pSortableColumn="spettacolo" class="w-1/5">Spettacolo <span class="inline-flex"><p-sortIcon field="spettacolo" /></span></th>
                <th pSortableColumn="dal" class="w-1/5">Dal <span class="inline-flex"><p-sortIcon field="dal" /></span></th>
                <th pSortableColumn="al" class="w-1/5">Al <span class="inline-flex"><p-sortIcon field="al" /></span></th>
                <th class="w-1/5 text-center">Azioni</th>
            </tr>
            <tr class="border-b">
                <th></th>
                <th>
                    <p-columnFilter type="text" field="spettacolo" placeholder="Filtra per Spettacolo" ariaLabel="Filtra per Spettacolo" [showClearButton]="false"  matchMode="contains" />
                </th>
                <th>
                    <p-columnFilter type="date" field="dal" matchMode="after" placeholder="Filtra per Data Dal" [showClearButton]="false" />
                </th>
                <th>
                    <p-columnFilter type="date" field="al" matchMode="before"  placeholder="Filtra per Data Al" [showClearButton]="false" />
                </th>
                <th></th>
            </tr>
            <tr>
                <th colspan="5" class="text-center">
                    <p-checkbox label="Spettacoli della stagione corrente" value="stagione" [(ngModel)]="stagione" (ngModelChange)="onStagione($event)" />
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-spettacolo>
            <tr>
                <td class="text-center h-full !justify-center">
                    <img #img [src]="(spettacolo.img_box + '?type=spettacolo' | image)"
                        class="rounded-full h-40 border shadow-lg text-center align-middle inline"
                        (error)="img.src= '../../../../assets/images/Noimage.png'">
                </td>
                <td colspan="3" class="!flex-col gap-2"><span class="p-column-title">Spettacolo</span>

                    <div class="data">
                        <h1 class="lg:text-2xl text-xl font-bold text-black">{{spettacolo.spettacolo}}</h1>
                        <div class="date mt-3">
                            <span><strong>Data: </strong></span>
                            <ng-container *ngIf="calculateDateDiff(spettacolo.dal, spettacolo.al) >= 1">
                                <span>{{spettacolo.dal | date: 'EEE dd MMM yyyy' | titlecase}} -
                                    {{spettacolo.al | date: 'EEE dd MMM yyyy' | titlecase}}</span>
                            </ng-container>
                            <ng-container *ngIf="calculateDateDiff(spettacolo.dal, spettacolo.al) <= 0">
                                <span>{{spettacolo.al | date: 'EEE dd MMM yyyy' | titlecase}}</span>
                            </ng-container>
                            <span class="ms-3"><strong>Prenotabile Dal:
                                </strong>{{(spettacolo.prenotabile_dal | date: 'EEE dd MMM yyyy' | titlecase) || '-'}}</span>
                        </div>
                        <div class="desc mt-3">
                            <span><strong>Compagnia:</strong></span>
                            <p>{{((spettacolo?.compagnia?.length > 100) ? (spettacolo.compagnia | slice: 0 : 100) + '...' : (spettacolo.compagnia)) || '-'}}
                            </p>
                            <span class="mt-3 block"><strong>Descrizione:</strong></span>
                            <p class="desc-spettacolo"
                                [innerHTML]="((spettacolo.descrizione?.length > 200) ? (spettacolo.descrizione | slice: 0 : 200) + '...' : (spettacolo.descrizione)) || '-'">
                            </p>
                        </div>
                    </div>

                </td>
                <td class="!justify-center">

                    <div class="flex flex-row items-center justify-center">
                        <i class="bi bi-pencil lg:text-3xl text-2xl hover:text-accent cursor-pointer" [routerLink]="'/backoffice/spettacoli/' + spettacolo.id"></i>                        
                        <p-divider layout="vertical"></p-divider>
                        @if (!spettacolo.evento) {                            
                            <i class="bi bi-person-square lg:text-3xl text-2xl hover:text-accent cursor-pointer" routerLink="/backoffice/spettacoli/{{spettacolo.id}}/utenti-area-compagnia"></i>                                                    
                            <p-divider layout="vertical"></p-divider>
                        }
                        <i class="bi bi-trash lg:text-3xl text-2xl hover:text-accent cursor-pointer" (click)="onOpenDeleteSpettacolo($event, spettacolo)"></i>                                                
                        
                    </div>
                    @if (spettacolo.evento) {
                    <div class="flex flex-row items-center justify-center">
                        <i class="bi bi-person-square lg:text-3xl text-2xl hover:text-accent cursor-pointer" routerLink="/backoffice/spettacoli/{{spettacolo.id}}/utenti-area-compagnia"></i>                        
                        <p-divider layout="vertical"></p-divider>
                        <i class="bi bi-ui-checks lg:text-3xl text-2xl hover:text-accent cursor-pointer" routerLink="/backoffice/spettacoli/{{spettacolo.id}}/area-compagnia"></i>
                        <p-divider layout="vertical"></p-divider>
                        <i class="bi bi-person-badge-fill lg:text-3xl text-2xl hover:text-accent cursor-pointer" routerLink="/backoffice/spettacoli/{{spettacolo.id}}/personale-area-compagnia"></i>
                    </div>
                    }
                    <p-confirmPopup #deleteSpettacolo>
                        <ng-template pTemplate="headless" let-message>
                            <div class="border-round p-3">
                                <span class="text-base">{{ message.message }}</span>
                                <div class="flex align-items-center gap-2 mt-3">
                                    <button type="button" class="text-center btn-danger-backoffice p-2 w-full font-medium" (click)="onDeleteSpettacolo()">Elimina</button>
                                    <button type="button" class="text-center btn-outln-backoffice p-2 w-full font-medium" (click)="onAnnullaDeleteSpettacolo()">Annulla</button>
                                </div>
                            </div>
                        </ng-template>
                    </p-confirmPopup>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="5">Nessuno spettacolo trovato.</td>
            </tr>
        </ng-template>
    </p-table>
</section>